module.exports = __webpack_public_path__ + "img/Pic_Sy_Lb_07.01a8be86.png";